const VALID_LOCALES = ['en', 'es', 'pt']

const getValidLocale = (locale) => {
  if (!locale) { return 'en' }
  locale = locale.toLowerCase()
  return VALID_LOCALES.includes(locale) ? locale : 'en'
}

export default getValidLocale
